var map = {
	"./locales/en-US.json": 4590,
	"./locales/es-ES.json": 66082,
	"./locales/pt-BR.json": 19825,
	"./locales/pt-PT.json": 18360,
	"./private/relatorio/locales/en-US.json": 42966,
	"./private/relatorio/locales/es-ES.json": 63336,
	"./private/relatorio/locales/pt-BR.json": 11890,
	"./private/relatorio/locales/pt-PT.json": 53663,
	"pages/locales/en-US.json": 4590,
	"pages/locales/es-ES.json": 66082,
	"pages/locales/pt-BR.json": 19825,
	"pages/locales/pt-PT.json": 18360,
	"pages/private/relatorio/locales/en-US.json": 42966,
	"pages/private/relatorio/locales/es-ES.json": 63336,
	"pages/private/relatorio/locales/pt-BR.json": 11890,
	"pages/private/relatorio/locales/pt-PT.json": 53663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56918;